var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('sidebar-item',{attrs:{"routes":_vm.menuRoutes}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }